import { render } from "./MetricCard.vue?vue&type=template&id=d5d15504&scoped=true&ts=true"
import script from "./MetricCard.vue?vue&type=script&lang=ts"
export * from "./MetricCard.vue?vue&type=script&lang=ts"

import "./MetricCard.vue?vue&type=style&index=0&id=d5d15504&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d15504"]])

export default __exports__